import stylusConfig from '@pb/kit-stylus/config.json';

/**
 * Converts a pixel value to a `rem` string using a configurable base font size.
 *
 * The base font size defaults to the project-wide value defined in
 * `@pb/kit-stylus/config.json` (`font.baseFont`), keeping rem calculations
 * consistent with the design system's root font size. Returns `null` when
 * `px` is `null`, `undefined`, or `0`, allowing callers to pass optional
 * dimension values without extra null-guards.
 *
 * @param px - Pixel value to convert. Pass `null` or `undefined` to get `null` back.
 * @param default_px - Base font size in px used as the divisor. Defaults to the
 *   project's global `font.baseFont` (typically `16`).
 * @returns The converted `rem` string (e.g. `"1.5rem"`) when `px` is a non-zero
 *   number, or `null` when `px` is falsy.
 *
 * @example
 * ```ts
 * convertPxToRem(24);     // → "1.5rem"  (24 / 16)
 * convertPxToRem(0);      // → null
 * convertPxToRem(null);   // → null
 * convertPxToRem(24, 10); // → "2.4rem"  (24 / 10)
 * ```
 */
export function convertPxToRem(
    px: number,
    default_px?: number
): string;
export function convertPxToRem(
    px: null | undefined,
    default_px?: number
): null;

export function convertPxToRem(
    px: number | null | undefined,
    default_px = stylusConfig.font.baseFont,
) {
    return px ? String(px / default_px) + 'rem' : null;
}
